<img class="plc-avatar__img" [class]="imgClasses" [src]="src" />
